(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rt-instructions"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-rt-instructions]').forEach(function(root) {
      var filters = root.querySelectorAll('[data-rt-filter]');
      var tiles = root.querySelectorAll('[data-rt-tile]');
      var panels = root.querySelectorAll('[data-rt-panel]');
      var backs = root.querySelectorAll('[data-rt-back]');
      var back = backs[0];
      var finder = root.querySelector('#rt-models');
      var backWrap = root.querySelector('[data-rt-back-wrap]');
      var hero = root.querySelector('.rt-ig-hero');
      var activeFilter = 'all';

      root.classList.add('rt-ig-ready');
      panels.forEach(function(panel) {
        panel.hidden = true;
      });

      function isGuideId(id) {
        var panel = id ? document.getElementById(id) : null;
        return Boolean(panel && panel.hasAttribute('data-rt-panel'));
      }

      function stickyOffset() {
        var height = 0;
        document.querySelectorAll('#SiteHeader, .site-header--stuck, .site-header').forEach(function(el) {
          var rect = el.getBoundingClientRect();
          if (rect.height < 20) return;
          if (rect.top <= 8 && rect.bottom > 0) {
            height = Math.max(height, rect.bottom);
          } else {
            height = Math.max(height, rect.height);
          }
        });
        if (height < 20) height = 72;
        return height + 8;
      }

      function afterLayout(fn) {
        requestAnimationFrame(function() {
          requestAnimationFrame(fn);
        });
      }

      function scrollToEl(el) {
        if (!el) return;
        var top = window.scrollY + el.getBoundingClientRect().top - stickyOffset();
        window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
      }

      function applyFilter() {
        tiles.forEach(function(tile) {
          var match = activeFilter === 'all' || tile.getAttribute('data-rt-category') === activeFilter;
          tile.hidden = !match;
        });
      }

      function closeGuide() {
        root.classList.remove('is-guide-open');
        panels.forEach(function(panel) {
          panel.classList.remove('is-open');
          panel.hidden = true;
        });
        tiles.forEach(function(tile) {
          tile.classList.remove('is-active');
        });
        applyFilter();
      }

      function openGuide(id) {
        if (!isGuideId(id)) {
          closeGuide();
          return;
        }
        root.classList.add('is-guide-open');
        panels.forEach(function(panel) {
          var open = panel.id === id;
          panel.classList.toggle('is-open', open);
          panel.hidden = !open;
        });
        tiles.forEach(function(tile) {
          var selected = tile.getAttribute('href') === '#' + id;
          tile.classList.toggle('is-active', selected);
          tile.hidden = !selected;
        });
      }

      function setHash(id) {
        var next = id ? '#' + id : (location.pathname + location.search);
        if (id && location.hash === '#' + id) return;
        if (!id && !location.hash) return;
        history.pushState({ rtGuide: id || null }, '', next);
      }

      filters.forEach(function(button) {
        button.addEventListener('click', function() {
          activeFilter = button.getAttribute('data-rt-filter') || 'all';
          filters.forEach(function(item) {
            item.classList.toggle('is-active', item === button);
          });
          if (root.classList.contains('is-guide-open')) return;
          applyFilter();
        });
      });

      tiles.forEach(function(tile) {
        tile.addEventListener('click', function(event) {
          var id = (tile.getAttribute('href') || '').replace('#', '');
          if (!isGuideId(id)) return;
          event.preventDefault();
          openGuide(id);
          setHash(id);
          afterLayout(function() {
            scrollToEl(backWrap || finder);
            if (back && typeof back.focus === 'function') {
              back.focus({ preventScroll: true });
            }
          });
        });
      });

      backs.forEach(function(link) {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          closeGuide();
          setHash(null);
          afterLayout(function() {
            scrollToEl(hero || finder || root);
          });
        });
      });

      window.addEventListener('popstate', function() {
        var id = location.hash.replace('#', '');
        if (isGuideId(id)) {
          openGuide(id);
          afterLayout(function() {
            scrollToEl(backWrap || finder);
          });
        } else {
          closeGuide();
          afterLayout(function() {
            scrollToEl(hero || finder || root);
          });
        }
      });

      var initial = location.hash.replace('#', '');
      if (isGuideId(initial)) {
        openGuide(initial);
        afterLayout(function() {
          scrollToEl(backWrap || finder);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rt-product-faqs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openHashFaq() {
      var hash = window.location.hash;
      if (!hash || hash.indexOf('#faq-') !== 0) return;
      var el = document.getElementById(hash.slice(1));
      if (el && el.tagName === 'DETAILS') {
        el.open = true;
        if (typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ block: 'nearest' });
        }
      }
    }
    openHashFaq();
    window.addEventListener('hashchange', openHashFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
